import styled from 'styled-components';

import media from '../../../utils/mediaQueries';
import {
  colors, radius, shadows, spacing,
} from '../tokens';

export const Panel = styled.div`
  max-width: 820px;
  width: 100%;
  margin: 0 auto;
  padding: ${spacing.xl};
  background-color: ${colors.surface};
  border: 1px solid ${colors.border};
  border-radius: ${radius.large};
  box-shadow: ${shadows.card};

  ${media.mobile`
    padding: 20px;
  `}
`;

export const StepTitle = styled.h2`
  font-size: 28px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0.2px;
  color: ${colors.text};
  margin: 0 0 ${spacing.sm};

  ${media.mobile`
    font-size: 22px;
  `}
`;

export const StepText = styled.p`
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.1px;
  color: ${colors.textMuted};
  margin: 0;
`;

export const BackLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0 ${spacing.lg};
  border: 1px solid ${colors.brand};
  border-radius: 4px;
  background-color: ${colors.surface};
  color: ${colors.brand};
  font-size: 16px;
  font-weight: bold;
  text-decoration: none;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.9;
    text-decoration: none;
  }
`;

export const ErrorBanner = styled.p`
  font-size: 14px;
  color: #f74656;
  margin: ${spacing.md} 0 0;
`;

// Step-appropriate reassurance copy (spec §5.4 — "no payment at this stage" on contact, "secure
// payment" on payment). Same weight as SummaryChoiceStep's local Caption.
export const Reassurance = styled.p`
  font-size: 12px;
  color: ${colors.textMuted};
  margin: ${spacing.md} 0 0;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.md};
  margin-top: ${spacing.lg};

  /* Even columns: the back control sizes to its text, the submit button to 100%, so both
     need the same flex basis to come out equal. */
  > * {
    flex: 1 1 0;
  }

  ${media.mobile`
    flex-direction: column-reverse;
    align-items: stretch;

    > * {
      flex: 0 0 auto;
    }
  `}
`;
